module.exports = __webpack_public_path__ + "img/icono-vista-pago.32d62fe0.svg";